export abstract class Flexi<T> {
    protected targets: T[] = [];

    public hasTargets() {
        return this.targets.length;
    }

    public addTarget(target: T) {
        if (target) {
            this.targets.push(target);
        }
    }

    public addTargets(targets: T[]) {
        if (targets) {
            if (targets.length) {
                for (const target of targets) {
                    this.addTarget(target);
                }
            }
        }
    }

    public destroy() {
        // Destroy method
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/elements/abstract-flexi.ts